'use client';

import Script from 'next/script';
import { useEffect } from 'react';

interface OneTrustScriptsProps {
  oneTrustAccount?: string;
}

export function OneTrustScripts({ oneTrustAccount }: OneTrustScriptsProps) {
  useEffect(() => {
    // Only load if user hasn't dismissed cookie notice
    const cookieNotice = localStorage.getItem('onetrust-dismissed');
    if (!cookieNotice && oneTrustAccount) {
      // Initialize dataLayer after hydration
      (window as any).dataLayer = (window as any).dataLayer || [];
    }
  }, [oneTrustAccount]);

  if (!oneTrustAccount) {
    return null;
  }

  return (
    <>
      <Script id="consent-default" strategy="beforeInteractive">
        {`
          window.dataLayer = window.dataLayer || []; 
          function gtag(){dataLayer.push(arguments);}
          gtag('set', 'developer_id.dNzMyY2', true);
          gtag('consent', 'default', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'wait_for_update': 500
          });
        `}
      </Script>

      {/* OneTrust Loader */}
      <Script
        id="onetrust"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-domain-script={oneTrustAccount}
        data-document-language="true"
        strategy="lazyOnload"
      />

      {/* OneTrust Consent Update */}
      <Script id="onetrust-wrapper" strategy="lazyOnload">
        {`
          function OptanonWrapper() { 
            if (typeof OnetrustActiveGroups !== 'undefined') {
              if (OnetrustActiveGroups.indexOf('2') !== -1) {
                gtag('consent', 'update', {'analytics_storage': 'granted'});
              }
              if (OnetrustActiveGroups.indexOf('C0004') !== -1) {
                gtag('consent', 'update', {
                  'ad_storage': 'granted',
                  'ad_user_data': 'granted',
                  'ad_personalization': 'granted'
                });
              }
            }
          }
        `}
      </Script>
    </>
  );
}
